import React, { useEffect, useState } from "react";
import Sidebar from "../../Sidebar";
import Header from "../../Header";
import { Link } from "react-router-dom";
import { API } from "../../../../API";
import { isAutheticated } from "../../../auth/authhelper";
import axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "../../Footer";
import swal from 'sweetalert'; // Import SweetAlert

export default function Subjects() {
  const [subjects, setsubjects] = useState([]);
  const [loading, setloading] = useState(false);
  // const [onSuspend,setOnSuspend]=useState(false);
  const [dataLoading, setdataLoading] = useState(true);


  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(10);
  const [showData, setShowData] = useState(subjects);

  const { token } = isAutheticated();
  useEffect(() => {
    // $("#summernote").summernote();
    setdataLoading(true)
    axios
      .get(
        `${API}/api/banner/viewbanner
      `,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        console.log(response?.data);
        const userdata = response.data.data;
        setsubjects(userdata);
        setdataLoading(false)

      })
      .catch((err) => {
        console.log(err);
        setdataLoading(false)

      });
  }, [loading, !loading]);

  const onDelete = async (id) => {
    const status = await swal({
      title: "Are you sure?",
      text: "Do you want to delete this Banner?",
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    });
    if (!status) {
      return;
    } else {
      setloading(true);
      axios
        .delete(`${API}/api/banner/delete_banner/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          setloading(false);
          // swal("Deleted!", "The Banner has been deleted successfully.", "success");

          //console.log(response);
        })
        .catch((err) => {
          setloading(false);
          swal("Error", "There was an issue deleting the category.", "error");

          console.log(err);
        });
    }
  };







  useEffect(() => {
    const loadData = () => {
      const indexOfLastPost = currentPage * itemPerPage;
      const indexOfFirstPost = indexOfLastPost - itemPerPage;
      setShowData(subjects.slice(indexOfFirstPost, indexOfLastPost));
    };

    loadData();
  }, [subjects, currentPage, itemPerPage]);
  const formatUSDate = (date) => {
    if (!date) return "—";
    return new Date(date).toLocaleDateString("en-US", {
      month: "short", // Nov
      day: "2-digit", // 17
      year: "numeric" // 2025
    });
  };
  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          {/* <!-- start page title --> */}
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Content Management - Banners</h4>

                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <a href=''>SoComOTT</a>
                    </li>
                    <li className='breadcrumb-item'>
                      Content Management - Banners
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          {/* <!-- end page title --> */}

          <div className='row'>
            <div className='col-lg-12'>
              <div className='card'>
                <div className='card-body'>
                  <div className='row ml-0 mr-0  mb-10'>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_length'>
                        <label className='w-100'>
                          Show{" "}
                          <select
                            name=''
                            className='select-w custom-select custom-select-sm form-control form-control-sm'
                            value={itemPerPage}
                            onChange={(e) => setItemPerPage(e.target.value)}>
                            <option value='10'>10</option>
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                            <option value='100'>100</option>
                          </select>{" "}
                          entries
                        </label>
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      <div className='dropdown d-block'>
                        <Link to='/subjects/add'>
                          <button
                            type='button'
                            className='btn btn-primary add-btn waves-effect waves-light float-right'>
                            <i className='fa fa-plus' aria-hidden='true'></i>{" "}
                            Add New Banner
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className='table-responsive table-shoot'>
                    <table className='table table-centered table-nowrap mb-0'>
                      <thead className='thead-light'>
                        <tr>
                          <th>Banner </th>
                          <th>Title</th>
                          <th>For Page</th>
                          <th>Start date</th>
                          <th>End Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataLoading ? (
                          <tr>
                            <td colSpan="10" align="center" style={{ padding: "20px" }}>
                              <div style={{ fontSize: "1.2rem", fontWeight: "bold", color: "#007bff" }}>
                                Loading...
                              </div>
                            </td>
                          </tr>
                        ) : showData?.length > 0 ? (
                          showData.map((subjects) => (
                            <tr key={subjects._id}>
                              <td>
                                <img
                                  src={
                                    subjects.bannerimage
                                      ? subjects.bannerimage
                                      : "/bannerDefault.png"
                                  }
                                  width='110'
                                  height='60'
                                  alt=''
                                />
                              </td>
                              <td>{subjects.title}</td>
                              <td>{subjects.category}</td>
                              <td>{formatUSDate(subjects.startdate)}</td>
                              <td>{formatUSDate(subjects.enddate)}</td>
                              <td>
                                {subjects.status &
                                  (new Date(subjects.enddate) > new Date()) ? (
                                  <span className='badge badge-pill badge-primary font-size-12'>
                                    Live
                                  </span>
                                ) : (
                                  <span className='badge badge-pill badge-soft-success font-size-12'>
                                    Live
                                  </span>
                                )}
                              </td>
                              <td>
                                {subjects.status && (
                                  <button
                                    type='button'
                                    disabled={
                                      new Date(subjects.enddate) <= new Date()
                                    }
                                    className='btn btn-success btn-sm  waves-effect waves-light btn-table'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      let data = new FormData();
                                      data.set("status", false);
                                      axios
                                        .patch(
                                          `${API}/api/banner/edit_banner/${subjects._id}`,
                                          data,
                                          {
                                            headers: {
                                              Authorization: `Bearer ${token}`,
                                              "Content-Type":
                                                "multipart/formdata",
                                            },
                                          }
                                        )
                                        .then((response) => {
                                          //console.log(response);
                                          setloading(!loading);
                                          // console.log(response);
                                        })
                                        .catch((err) => {
                                          console.log(err);
                                        });
                                    }}>
                                    Suspend
                                  </button>
                                )}
                                {!subjects.status && (
                                  <button
                                    type='button'
                                    className='btn btn-success btn-sm  waves-effect waves-light btn-table'
                                    onClick={(e) => {
                                      e.preventDefault();
                                      let data = new FormData();
                                      data.set("status", true);
                                      axios
                                        .patch(
                                          `${API}/api/banner/makelive/${subjects._id}`,
                                          data,
                                          {
                                            headers: {
                                              Authorization: `Bearer ${token}`,
                                              "Content-Type":
                                                "multipart/formdata",
                                            },
                                          }
                                        )
                                        .then((response) => {
                                          console.log(response);
                                          setloading(!loading);
                                          // console.log(response);
                                        })
                                        .catch((err) => {
                                          console.log(err);
                                        });
                                    }}>
                                    MakeLive
                                  </button>
                                )}
                                <Link to={`/subjects/edit/${subjects._id}`}>
                                  <button
                                    type='button'
                                    className='btn btn-primary btn-sm  waves-effect waves-light btn-table ml-2'>
                                    Edit
                                  </button>
                                </Link>
                                <Link to='#'>
                                  <button
                                    type='button'
                                    disabled={
                                      new Date(subjects.enddate) <= new Date()
                                    }
                                    onClick={() => {
                                      onDelete(subjects._id);
                                    }}
                                    className='btn btn-danger btn-sm  waves-effect waves-light btn-table ml-2'>
                                    Delete
                                  </button>
                                </Link>
                              </td>
                            </tr>
                          )))
                          : (
                            <tr>
                              <td colSpan="5" className="text-center py-4" style={{ fontSize: "1.25rem", fontWeight: "bold", color: "#ff0000" }}>
                                No Banner Found. Please add New Banner to display here.
                              </td>
                            </tr>
                          )}
                      </tbody>
                    </table>
                  </div>

                  <div className='row mt-20'>
                    <div className='col-sm-12 col-md-6 mb-20'>
                      <div
                        className='dataTables_info'
                        id='datatable_info'
                        role='status'
                        aria-live='polite'>
                        Showing {currentPage * itemPerPage - itemPerPage + 1} to{" "}
                        {Math.min(currentPage * itemPerPage, subjects.length)}{" "}
                        of {subjects.length} entries
                      </div>
                    </div>

                    <div className='col-sm-12 col-md-6'>
                      <div className='dataTables_paginate paging_simple_numbers float-right'>
                        <ul className='pagination'>
                          <li
                            className={
                              currentPage === 1
                                ? "paginate_button page-item previous disabled"
                                : "paginate_button page-item previous"
                            }>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='0'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev - 1)
                              }>
                              Previous
                            </a>
                          </li>

                          {!(currentPage - 1 < 1) && (
                            <li className='paginate_button page-item'>
                              <a
                                aria-controls='datatable'
                                data-dt-idx='1'
                                tabIndex='0'
                                className='page-link'
                                onClick={(e) =>
                                  setCurrentPage((prev) => prev - 1)
                                }>
                                {currentPage - 1}
                              </a>
                            </li>
                          )}

                          <li className='paginate_button page-item active'>
                            <a
                              href='#'
                              aria-controls='datatable'
                              data-dt-idx='2'
                              tabIndex='0'
                              className='page-link'>
                              {currentPage}
                            </a>
                          </li>

                          {!(
                            (currentPage + 1) * itemPerPage - itemPerPage >
                            subjects.length
                          ) && (
                              <li className='paginate_button page-item '>
                                <a
                                  href='#'
                                  aria-controls='datatable'
                                  data-dt-idx='3'
                                  tabIndex='0'
                                  className='page-link'
                                  onClick={() => {
                                    setCurrentPage((prev) => prev + 1);
                                  }}>
                                  {currentPage + 1}
                                </a>
                              </li>
                            )}

                          <li
                            className={
                              !(
                                (currentPage + 1) * itemPerPage - itemPerPage >
                                subjects.length
                              )
                                ? "paginate_button page-item next"
                                : "paginate_button page-item next disabled"
                            }>
                            <a
                              href='#'
                              tabIndex='0'
                              className='page-link'
                              onClick={() =>
                                setCurrentPage((prev) => prev + 1)
                              }>
                              Next
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  {/* <!-- end table-responsive --> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- container-fluid --> */}
      </div>
      {/* <!-- End Page-content --> */}

      <Footer />
    </div >
  );
}
